import React, { Component } from 'react';
import { FaRegFileExcel, FaRegFilePdf } from "react-icons/fa";
import { ToastContainer, toast, Flip } from 'react-toastify';
import Table from 'react-bootstrap/Table';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import NavTabs from "../home/NavTabs";
import moment from 'moment';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { saveAs } from "file-saver";
import XlsxPopulate from "xlsx-populate";
import { FaSortAmountDown, FaSortAmountUp } from "react-icons/fa";

import ThFilter from "./ThFilter";

import "./Report.css";

import * as backendApi from '../../services/api';

export default class ReportSheriff extends Component {

  notifyError = () => toast.error('Too much data to fetch. Try select using 3 or 6 month intervals.', { delay: 0, containerId: 'error', autoClose: 2000 });

  constructor(props) {
    super(props);

    this.state = {
      reportSheriff: [],
      clients: [],
      courts: [],
      process: [],
      plaintiffs: [],
      sheriffs: [],
      status: [],
      filterArray: [],
      filterLookup: {},
      dateSelections: [],
      clientName: "",
      timeframe: "",
      month3Check: false,
      month6Check: false,
      lastKeyRef: "",
      client: ""
    };
  }

  componentDidMount() {
    const myData = JSON.parse(localStorage.getItem("myData"));

    const clients = JSON.parse(localStorage.getItem('clients'));
    const courts = JSON.parse(localStorage.getItem('courts'));
    const process = JSON.parse(localStorage.getItem('process'));
    const plaintiffs = JSON.parse(localStorage.getItem('plaintiffs'));
    const sheriffs = JSON.parse(localStorage.getItem('sheriffs'));
    const yearNow = new Date().getFullYear();

    var isClient = false;
    myData.userRoles.forEach((item, i) => {
      if (item.name === "QuickView") {
        isClient = true;
      }
    });

    if (isClient) {
      for (var c = 0; c < clients.length; c++) {
        let client = clients[c].name;

        if (client !== myData.client) {
          clients.splice(c, 1);
          c--;
        }
      }
    }

    this.setState({
      clients: clients,
      courts: courts,
      process: process,
      plaintiffs: plaintiffs,
      sheriffs: sheriffs,
      dateSelections: [{
        name: "Last Week"
      }, {
        name: "Last Month"
      }, {
        name: "Last Year"
      }],
      timeframe: yearNow
    });

    if (isClient) {
      this.onClientSelected(myData.client);
    }
  }

  onClientSelected = async (client) => {
    this.setState({
      reportSheriff: [],
      unfilteredRows: [],
      filterArray: [],
      filterLookup: {},
      client: client,
      keyRefList: []
    });

    let keyRefList = [];
    if (client !== "") {
      this.props.loading(true);

      try {
        const allItems = await backendApi.getReportList("isSheriff", client, this.state.timeframe, "");
        let unfilteredRows = [];
        let reports = [];

        allItems.forEach((item) => {
          if (item.lastKeyRef) {
            this.setState({ lastKeyRef: item.lastKeyRef });
            keyRefList.push({ lastKeyRef: item.lastKeyRef });
          } else {
            // item.sheriff[0].batchNumber = item.batchNumber;
            // item.sheriff[0].caseNumber = item.caseNumber;
            // item.sheriff[0].client = item.client;
            // item.sheriff[0].refNumber = item.refNumber;

            reports.push(item[0]);
            unfilteredRows.push(item[0]);
            if (item.caseNumber === "") {
              console.log(item.barcode);
            }
          }
        });

        this.setState({
          reportSheriff: reports,
          unfilteredRows: unfilteredRows,
          clientName: client,
          keyRefList: keyRefList
        });

        if (this.state.lastKeyRef !== "") {
          this.getMoreItems(client);
        } else {
          this.props.loading(false);
        }

      } catch (e) {
        this.props.loading(false);
        this.notifyError();
      }
    } else {
      this.setState({ month3Check: false, month6Check: false });
    }
  }

  onClientSwitched = (newClient) => {
    const myData = JSON.parse(localStorage.getItem("myData"));
    if (myData) {
      myData.client = newClient;
      localStorage.setItem("myData", JSON.stringify(myData));
    }
    this.setState({ clientName: newClient, client: newClient });
    this.onClientSelected(newClient);
  }

  getMoreItems = async (client) => {
    let lastKeyRef = "";
    try {
      let keyRefList = this.state.keyRefList;
      let refSearchValues = "";

      for (var i = 0; i < keyRefList.length; i++) {
        let lastKeyRefSearch = keyRefList[i].lastKeyRef;
        if (lastKeyRefSearch.includes("/")) {
          lastKeyRefSearch = lastKeyRefSearch.replace(/\//g, 'slash');
        }
        refSearchValues += lastKeyRefSearch + "+";
      }
      const allItems = await backendApi.getReportList("isSheriff", client, this.state.timeframe, refSearchValues);
      let unfilteredRows = JSON.stringify(this.state.unfilteredRows);
      let reports = JSON.stringify(this.state.reportSheriff);

      let unRows = JSON.parse(unfilteredRows);
      let reps = JSON.parse(reports);

      allItems.forEach((item) => {

        if (item.lastKeyRef) {
          this.setState({ lastKeyRef: item.lastKeyRef });
          keyRefList.push({ lastKeyRef: item.lastKeyRef });
          lastKeyRef = item.lastKeyRef;
        } else {
          item.sheriff[0].batchNumber = item.batchNumber;
          item.sheriff[0].caseNumber = item.caseNumber;
          item.sheriff[0].client = item.client;
          item.sheriff[0].refNumber = item.refNumber;

          reps.push(item.sheriff[0]);
          unRows.push(item.sheriff[0]);
        }

      });

      this.setState({
        reportSheriff: reps,
        unfilteredRows: unRows,
        keyRefList: keyRefList
      });

      if (lastKeyRef !== "") {
        this.getMoreItems(client);
      } else {
        this.props.loading(false);
      }

    } catch (e) {
      this.props.loading(false);
      this.notifyError();
    }
  }

  onTimeframeSelected = (year) => {
    this.setState({ timeframe: year });
  }

  filterDate = (value, field, filteredItems) => {
    let lastWeekStart = moment().subtract(1, "weeks").startOf("week").format("DD/MM/YYYY");
    let lastWeekEnd = moment().subtract(1, "weeks").endOf("week").format("DD/MM/YYYY");
    let lastMonthStart = moment().subtract(1, "months").startOf("month").format("DD/MM/YYYY");
    let lastMonthEnd = moment().subtract(1, "months").endOf("month").format("DD/MM/YYYY");
    let lastYearStart = moment().subtract(1, "years").startOf("year").format("DD/MM/YYYY");
    let lastYearEnd = moment().subtract(1, "years").endOf("year").format("DD/MM/YYYY");

    let rows = [];

    let dateToClient = "";
    let dateCreatedOn = "";
    let dateToSheriff = "";

    switch (value.name) {

      case "Last Week":
        console.log(lastWeekStart + " : " + lastWeekEnd);

        filteredItems.forEach((row, i) => {
          let isInRange = false;

          dateToClient = row.toClient.substr(6, 4) + "-" + row.toClient.substr(3, 2) + "-" + row.toClient.substr(0, 2);
          dateCreatedOn = row.createdOn.substr(6, 4) + "-" + row.createdOn.substr(3, 2) + "-" + row.createdOn.substr(0, 2);
          dateToSheriff = row.toSheriff.substr(6, 4) + "-" + row.toSheriff.substr(3, 2) + "-" + row.toSheriff.substr(0, 2);

          switch (field) {
            case "dateCreate":
              isInRange = moment(dateCreatedOn).isBetween(lastWeekStart, lastWeekEnd);
              if (isInRange) {
                rows.push(row);
              }
              break;

            case "dateSheriff":
              isInRange = moment(dateToSheriff).isBetween(lastWeekStart, lastWeekEnd);
              if (isInRange) {
                rows.push(row);
              }
              break;

            case "dateClient":
              isInRange = moment(dateToClient).isBetween(lastWeekStart, lastWeekEnd);
              if (isInRange) {
                rows.push(row);
              }
              break;
            default:
          }
        });

        break;

      case "Last Month":
        console.log(lastMonthStart + " : " + lastMonthEnd);

        filteredItems.forEach((row, i) => {
          let isInRange = false;

          dateToClient = row.toClient.substr(6, 4) + "-" + row.toClient.substr(3, 2) + "-" + row.toClient.substr(0, 2);
          dateCreatedOn = row.createdOn.substr(6, 4) + "-" + row.createdOn.substr(3, 2) + "-" + row.createdOn.substr(0, 2);
          dateToSheriff = row.toSheriff.substr(6, 4) + "-" + row.toSheriff.substr(3, 2) + "-" + row.toSheriff.substr(0, 2);

          switch (field) {
            case "dateCreate":
              isInRange = moment(dateCreatedOn).isBetween(lastMonthStart, lastMonthEnd);
              if (isInRange) {
                rows.push(row);
              }
              break;

            case "dateSheriff":
              isInRange = moment(dateToSheriff).isBetween(lastMonthStart, lastMonthEnd);
              if (isInRange) {
                rows.push(row);
              }
              break;

            case "dateClient":
              isInRange = moment(dateToClient).isBetween(lastMonthStart, lastMonthEnd);
              if (isInRange) {
                rows.push(row);
              }
              break;
            default:
          }
        });
        break;

      case "Last Year":
        console.log(lastYearStart + " : " + lastYearEnd);

        filteredItems.forEach((row, i) => {
          let isInRange = false;

          dateToClient = row.toClient.substr(6, 4) + "-" + row.toClient.substr(3, 2) + "-" + row.toClient.substr(0, 2);
          dateCreatedOn = row.createdOn.substr(6, 4) + "-" + row.createdOn.substr(3, 2) + "-" + row.createdOn.substr(0, 2);
          dateToSheriff = row.toSheriff.substr(6, 4) + "-" + row.toSheriff.substr(3, 2) + "-" + row.toSheriff.substr(0, 2);

          switch (field) {
            case "dateCreate":
              isInRange = moment(dateCreatedOn).isBetween(lastYearStart, lastYearEnd);
              if (isInRange) {
                rows.push(row);
              }
              break;

            case "dateSheriff":
              isInRange = moment(dateToSheriff).isBetween(lastYearStart, lastYearEnd);
              if (isInRange) {
                rows.push(row);
              }
              break;

            case "dateClient":
              isInRange = moment(dateToClient).isBetween(lastYearStart, lastYearEnd);
              if (isInRange) {
                rows.push(row);
              }
              break;
            default:
          }
        });
        break;
      default:

        if (value.name.length > 3) {
          filteredItems.forEach((row, i) => {
            switch (field) {
              case "dateCreate":
                if (row.createdOn !== null && row.createdOn.includes(value.name)) {
                  rows.push(row);
                }
                break;

              case "dateSheriff":
                if (row.fromSheriff !== null && row.fromSheriff.includes(value.name)) {
                  rows.push(row);
                }
                break;

              case "dateClient":
                if (row.toClient !== null && row.toClient.includes(value.name)) {
                  rows.push(row);
                }
                break;
              default:
            }
          });
        } else {
          rows = filteredItems;
        }
    }

    return rows;
  }

  filterDropdowns = (value, field) => {

    value = value.toUpperCase();

    let clients = JSON.parse(localStorage.getItem('clients'));
    let courts = JSON.parse(localStorage.getItem('courts'));
    let process = JSON.parse(localStorage.getItem('process'));
    let plaintiffs = JSON.parse(localStorage.getItem('plaintiffs'));
    let sheriffs = JSON.parse(localStorage.getItem('sheriffs'));

    switch (field) {
      case "client":
        clients = clients.filter(item => item.name.includes(value));
        break;
      case "court":
        courts = courts.filter(item => item.name.includes(value));
        break;
      case "process":
        process = process.filter(item => item.name.includes(value));
        break;
      case "plaintiff":
        plaintiffs = plaintiffs.filter(item => item.name.includes(value));
        break;
      case "sheriff":
        sheriffs = sheriffs.filter(item => item.name.includes(value));
        break;
      default:

    }

    this.setState({
      clients: clients,
      courts: courts,
      process: process,
      plaintiffs: plaintiffs,
      sheriffs: sheriffs
    });
  }

  filterEntries = (filteredItems, filter, fromInput) => {
    let rows = [];
    const column = filter.columnName;

    filteredItems.forEach((row, i) => {

      switch (column) {
        case "refNumber":
        case "caseNumber":
        case "batchNumber":

          for (var val in filter.values) {
            if (row[column].includes(val)) {
              rows.push(row);
            }
          }

          break;
        default:
          if (row[column] in filter.values) {
            rows.push(row);
          }
      }

    });

    return rows;
  }

  onCheckSelected = (e, item, field, fromInput) => {

    let filterArray = this.state.filterArray;
    let filteredItems = this.state.unfilteredRows;
    let filterLookup = this.state.filterLookup;

    if (!(field in filterLookup)) {

      let obj = {
        columnName: field, //client, process, count etc
        values: {}
      }

      obj.values[item.name] = 1;

      filterLookup[field] = 1;

      filterArray.push(obj);
    } else if (!e.target.checked && !fromInput && !field.includes("date")) {

      for (var i = 0; i < filterArray.length; i++) {
        if (filterArray[i].columnName === field) {
          delete filterArray[i].values[item.name];
        }
        let removeFilter = true;
        for (var prop in filterArray[i].values) {
          if (filterArray[i].values.hasOwnProperty(prop)) {
            removeFilter = false;
          }
        }
        if (removeFilter) {
          filterArray.splice(i, 1);
          i--;
          delete filterLookup[field];
        }

      }

    } else {
      filterArray.forEach((filter, i) => {

        if (fromInput && filter.columnName === field) {

          for (var val in filter.values) {
            delete filter.values[val];
            filter.values[item.name] = 1;
            break;
          }

        } else if (filter.columnName === field) {
          filter.values[item.name] = 1;
        }

      });
    }

    if (filterArray.length !== 0) {

      filterArray.forEach((filter, i) => {

        if (filter.columnName.includes("date") || filter.columnName.includes("fromSheriff")) {

          for (var prop in filter.values) {
            item = { name: prop };
          }

          filteredItems = this.filterDate(item, filter.columnName, filteredItems);
        } else {
          filteredItems = this.filterEntries(filteredItems, filter, fromInput);
        }

      });
    }

    this.setState({
      reportSheriff: filteredItems,
      filterArray: filterArray,
      filterLookup: filterLookup
    });
  }

  getSheetData(data, header) {
    var fields = Object.keys(data[0]);
    var sheetData = data.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName] ? row[fieldName] : "";
      });
    });
    sheetData.unshift(header);
    return sheetData;
  }

  saveAsExcel = async () => {
    const data = this.state.reportSheriff.map(row => {
      const caseNumberYear = row.caseNumber.includes('/') ? `20${row.caseNumber.split('/')[1]}` : '-';
      return {
        "Date Created": row.createdOn ? `'${row.createdOn}` : "-",
        "Client": row.client ? `'${row.client}` : "-",
        "Ref Number": row.refNumber ? `'${row.refNumber}` : "-",
        "Defendant": row.defendant ? `'${row.defendant}` : "-",
        "Case Number": row.caseNumber ? `'${row.caseNumber}` : "-",
        "Case Number Year": caseNumberYear ? `'${caseNumberYear}` : "-",
        "Sheriff": row.sheriff ? `'${row.sheriff}` : "-",
        "From Sheriff": row.fromSheriff ? `'${row.fromSheriff}` : "-",
        "Batch": row.batchNumber ? `'${row.batchNumber}` : "-",
        "To Client": row.toClient ? `'${row.toClient}` : "-"
      }
    });

    const headers = Object.keys(data[0]);

    XlsxPopulate.fromBlankAsync().then(async workbook => {
      const sheet = workbook.sheet(0);
      sheet.cell("A1").value(this.getSheetData(data, headers));
      sheet.row(1).style("bold", true);

      headers.forEach((header, colIndex) => {
        const columnLetter = String.fromCharCode(65 + colIndex);
        const maxWidth = Math.max(
          ...data.map(row => (row[header]?.toString().length || 0)),
          header.length
        );
        sheet.column(columnLetter).width(Math.min(maxWidth + 2, 25));
      });

      const endColumn = String.fromCharCode(64 + headers.length);
      sheet.range(`A1:${endColumn}1`).style("border", true);

      return workbook.outputAsync().then(res => saveAs(res, "SheriffReport.xlsx"));
    });
  };

  exportPDF = () => {
    const unit = "px";
    const size = "A4";
    const orientation = "landscape";

    const marginLeft = 20;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);
    const title = "Sheriff Report";

    const headers = [[
      "Client", "Ref Number", "Defendant", "Case Number", "Sheriff",
      "From Sheriff", "Batch", "To Client"
    ]];

    let tableData = this.state.reportSheriff;

    tableData.forEach((item, i) => {
      item.fromSheriff = item.fromSheriff !== "" ? item.fromSheriff : "";
      item.toClient = item.toClient !== "" ? item.toClient : "";
    });

    const data = tableData.map(elt => [
      elt.client, elt.refNumber, elt.defendant, elt.caseNumber,
      elt.sheriff, elt.fromSheriff, elt.batchNumber,
      elt.toClient
    ]);

    let content = {
      startY: 40,
      head: headers,
      body: data
    };

    doc.text(title, marginLeft, 20);
    doc.autoTable(content);
    doc.save("SheriffReport.pdf")
  }

  onMonthsSelected = (selected, months) => {
    this.setState({ timeframe: months, client: "" });

    if (selected && months === "3months") {
      this.setState({ month3Check: true });
      this.setState({ month6Check: false });

    } else if (selected && months === "6months") {
      this.setState({ month6Check: true });
      this.setState({ month3Check: false });

    } else if (!selected && months === "3months") {
      this.setState({ month3Check: false });
      this.setState({ month6Check: true });

    } else if (!selected && months === "6months") {
      this.setState({ month6Check: false });
      this.setState({ month3Check: true });

    }
  }

  sortByCaseNumberAsc = () => {
    const sortedData = [...this.state.reportSheriff].sort((a, b) => {
      const caseA = a.caseNumber.split("/")[1] || "0";
      const caseB = b.caseNumber.split("/")[1] || "0";
      return parseInt(caseA) - parseInt(caseB);
    });

    this.setState({ reportSheriff: sortedData });
  };

  sortByCaseNumberDesc = () => {
    const sortedData = [...this.state.reportSheriff].sort((a, b) => {
      const caseA = a.caseNumber.split("/")[1] || "0";
      const caseB = b.caseNumber.split("/")[1] || "0";
      return parseInt(caseB) - parseInt(caseA);
    });

    this.setState({ reportSheriff: sortedData });
  };

  render() {
    return (
      <div className="Summons">

        <ToastContainer enableMultiContainer containerId={'error'} transition={Flip} position={toast.POSITION.TOP_CENTER} />

        <NavTabs className="nav-tabs" rootProps={this.props.history} auth={this.props.roles} />

        <div className="table-container">
          <div className="sheriff-heading-report">

            {"QuickView" in this.props.roles ?
              <div className="report-select-client align-items-center">
                {this.props.isPartnerUser ? (
                  <div className="col-auto pl-0">
                    <Form.Control style={{ width: "13rem" }} as="select" custom value={this.state.clientName}
                      onChange={e => this.onClientSwitched(e.target.value)}>
                      <option value="CLASSIC LEGAL">CLASSIC LEGAL</option>
                      <option value="DYNAMIC LEGAL">DYNAMIC LEGAL</option>
                    </Form.Control>
                  </div>
                ) : (
                  <div className="col-auto pl-0">
                    <span style={{ fontSize: "1.5rem" }}>
                      {this.state.clientName}
                    </span>
                  </div>
                )}
              </div>
              :

              <div className="report-select-client align-items-center">
                <div className="col-auto pl-0">
                  <span style={{ fontSize: "1.1rem", fontWeight: "bold", whiteSpace: "nowrap" }}>Select Client: </span>
                </div>
                <div className="col-auto pl-0 mr-2">
                  <Form.Control as="select" custom value={this.state.client}
                    onChange={e => this.onClientSelected(e.target.value)}>

                    {this.state.clients.map((client, index) => (
                      <option key={index} >{client.name}</option>
                    ))}

                  </Form.Control>
                </div>

                <div className="col-auto pl-0">
                  <Form.Control style={{ width: "10rem" }} as="select" custom value={this.state.timeframe}
                    onChange={e => this.onTimeframeSelected(e.target.value)}>

                    <option key="1">2019</option>
                    <option key="2">2020</option>
                    <option key="3">2021</option>
                    <option key="4">2022</option>
                    <option key="5">2023</option>
                    <option key="6">2024</option>
                    <option key="7">2025</option>
                    <option key="7">2026</option>
                    <option key="8"></option>

                  </Form.Control>
                </div>

              </div>
            }

            <div>
              <h3>SHERIFF RETURNS REPORT</h3>
            </div>

            <FaRegFileExcel className="print-excel-button" onClick={this.saveAsExcel} />
            <FaRegFilePdf className="print-pdf-button" onClick={this.exportPDF} />
          </div>

          <Table id="reportSheriff" striped bordered hover size="sm" responsive="sm" className="report-table sheriff-report-table">
            <thead>
              <tr>
                <th>
                  <Dropdown className="report-filter-dropdown">
                    <Dropdown.Toggle variant="" split>Date Created</Dropdown.Toggle>
                    <ThFilter onFilter={this.onFilter} list={this.state.dateSelections}
                      onCheckSelected={this.onCheckSelected} filterDate={this.filterDate} field="dateCreate" />
                  </Dropdown>
                </th>
                <th>
                  <Dropdown className="report-filter-dropdown">
                    <Dropdown.Toggle variant="" split>Client</Dropdown.Toggle>
                    <ThFilter onFilter={this.onFilter} list={this.state.clients}
                      onCheckSelected={this.onCheckSelected} filterDate={this.filterDropdowns} field="client" />
                  </Dropdown>
                </th>
                <th>
                  <Dropdown className="report-filter-dropdown">
                    <Dropdown.Toggle variant="" split>Ref Number</Dropdown.Toggle>
                    <Dropdown.Menu className="report-filter-dropdown-menu">
                      <Form.Control id="searchInput" type="text" onChange={e => this.onCheckSelected(e, { name: e.target.value }, "refNumber", true)} />
                    </Dropdown.Menu>
                  </Dropdown>
                </th>
                <th>
                  <Dropdown className="report-filter-dropdown">
                    <Dropdown.Toggle variant="" split>Defendant</Dropdown.Toggle>
                    <Dropdown.Menu className="report-filter-dropdown-menu">
                      <Form.Control id="searchInput" type="text" onChange={e => this.onCheckSelected(e, { name: e.target.value }, "defendant", true)} />
                    </Dropdown.Menu>
                  </Dropdown>
                </th>
                <th>
                  <Dropdown className="report-filter-dropdown">
                    <Dropdown.Toggle variant="" split>
                      Case Number
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="report-filter-dropdown-menu">
                      <Dropdown.Item onClick={this.sortByCaseNumberAsc}>
                        <FaSortAmountUp style={{ marginRight: "8px" }} />
                        Sort Ascending
                      </Dropdown.Item>
                      <Dropdown.Item onClick={this.sortByCaseNumberDesc}>
                        <FaSortAmountDown style={{ marginRight: "8px" }} />
                        Sort Descending
                      </Dropdown.Item>
                      <Form.Control
                        id="searchInput"
                        type="text"
                        onChange={(e) =>
                          this.onCheckSelected(e, { name: e.target.value }, "caseNumber", true)
                        }
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                </th>
                <th>
                  <Dropdown className="report-filter-dropdown">
                    <Dropdown.Toggle variant="" split>Sheriff</Dropdown.Toggle>
                    <ThFilter onFilter={this.onFilter} list={this.state.sheriffs}
                      onCheckSelected={this.onCheckSelected} filterDropdowns={this.filterDropdowns} field="sheriff" />
                  </Dropdown>
                </th>
                <th>
                  <Dropdown className="report-filter-dropdown">
                    <Dropdown.Toggle variant="" split>From Sheriff</Dropdown.Toggle>
                    <ThFilter onFilter={this.onFilter} list={this.state.dateSelections}
                      onCheckSelected={this.onCheckSelected} filterDate={this.filterDate} field="dateSheriff" />
                  </Dropdown>
                </th>
                <th>
                  <Dropdown className="report-filter-dropdown">
                    <Dropdown.Toggle variant="" split>Batch</Dropdown.Toggle>
                    <Dropdown.Menu className="report-filter-dropdown-menu">
                      <Form.Control id="searchInput" type="text" onChange={e => this.onCheckSelected(e, { name: e.target.value }, "batchNumber", true)} />
                    </Dropdown.Menu>
                  </Dropdown>
                </th>
                <th>
                  <Dropdown className="report-filter-dropdown">
                    <Dropdown.Toggle variant="" split>To Client</Dropdown.Toggle>
                    <ThFilter onFilter={this.onFilter} list={this.state.dateSelections}
                      onCheckSelected={this.onCheckSelected} filterDate={this.filterDate} field="dateClient" />
                  </Dropdown>
                </th>
              </tr>
            </thead>
            <tbody>

              {this.state.reportSheriff.map((row, index) => (
                <tr key={index}>

                  <td>{row.createdOn}</td>
                  <td>{row.client}</td>
                  <td>{row.refNumber}</td>
                  <td>{row.defendant}</td>
                  <td>{row.caseNumber}</td>
                  <td>{row.sheriff}</td>
                  <td>{row.fromSheriff}</td>
                  <td>{row.batchNumber}</td>
                  <td>{row.toClient}</td>

                </tr>
              ))}

            </tbody>
          </Table>

        </div>

      </div>
    )
  }
}
